import { createSlice } from "@reduxjs/toolkit";

export const taskCountSlice = createSlice({
  name: "taskCount",
  initialState: {
    forArchiving: 0,
    forReview: 0,
    forSigning: 0,
    forAssigning: 0,
  },
  reducers: {
    setTaskCounts: (state, action) => {
      state.forArchiving = action.payload.forArchiving;
      state.assignedToUser = action.payload.assignedToUser;
      state.forSigning = action.payload.forSigning;
      state.forAssigning = action.payload.forAssigning;
      console.log(
        "NEW STATE",
        state?.forArchiving,
        state?.assignedToUser,
        state?.forSigning,
        state?.forAssigning,
      );
    },
  },
});

export const { setTaskCounts } = taskCountSlice.actions;
export default taskCountSlice.reducer;
